import { format } from 'date-fns';
import { toastr } from 'react-redux-toastr';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { store } from '~/store';
import { ResponseProps } from '../../../propsGlobal/responseProps';
import {
  changeStateConsentimentosRequest,
  changeStateConsentimentosSuccess,
  consentimentosFailure,
  consentimentosRequest,
  consentimentosSuccess,
  contratosFailure,
  contratosRequest,
  contratosSuccess,
  getOrderHandleChangePageRequest,
  getOrderHandleChangeRowsPerPageRequest,
  postConsentimentosFailure,
  postConsentimentosRequest,
  postConsentimentosSuccess,
  resetConsentimentosSuccess,
} from './actions';
import { ConsentimentosType } from './types';

function* contratos({ payload }: ReturnType<typeof contratosRequest>) {
  try {
    const response: ResponseProps = yield call(api.get, '/v1/contratos', {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    yield put(contratosSuccess(response.data));
  } catch (error) {
    yield put(contratosFailure());
  }
}

function* consentimentos({
  payload,
}: ReturnType<typeof consentimentosRequest>) {
  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/consentimentos?pageNo=${payload.newPage}&pageSize=${payload.rowsPerPage}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    const { body } = response.data.data;

    const consentimentos: any = [];

    //@ts-ignore
    body.forEach(element => {
      if (element.operation_id && element.operation_describe) {
        consentimentos.push({
          personal_consent_policy_id: element.personal_consent_policy_id,
          personal_id: element.personal_id,
          codigo: element.operation_id,
          isActive: element.personal_response,
          atividade: element.operation_describe,
          data: format(new Date(element.modify_dt), 'dd/MM/yyyy'),
          total_itens: element.total_itens,
        });
      }
    });

    yield put(consentimentosSuccess(consentimentos));
  } catch (error) {
    yield put(consentimentosFailure());
  }
}

function* getOrderHandleChangeRowsPerPage({
  payload,
}: ReturnType<typeof getOrderHandleChangeRowsPerPageRequest>) {
  const { token } = store.getState().auth;

  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/consentimentos?pageNo=${payload.newPage}&pageSize=${payload.rowsPerPage}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );

    const { body } = response.data.data;

    const consentimentos: any = [];

    //@ts-ignore
    body.forEach(element => {
      if (element.operation_id && element.operation_describe) {
        consentimentos.push({
          personal_consent_policy_id: element.personal_consent_policy_id,
          personal_id: element.personal_id,
          codigo: element.operation_id,
          isActive: element.personal_response,
          atividade: element.operation_describe,
          data: format(new Date(element.modify_dt), 'dd/MM/yyyy'),
          total_itens: element.total_itens,
        });
      }
    });

    yield put(consentimentosSuccess(consentimentos));
  } catch (error) {
    yield put(consentimentosFailure());
  }
}

function* getOrderHandleChange({
  payload,
}: ReturnType<typeof getOrderHandleChangePageRequest>) {
  const { token } = store.getState().auth;

  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/consentimentos?pageNo=${payload.newPage}&pageSize=${payload.rowsPerPage}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );

    const { body } = response.data.data;

    const consentimentos: any = [];

    //@ts-ignore
    body.forEach(element => {
      if (element.operation_id && element.operation_describe) {
        consentimentos.push({
          personal_consent_policy_id: element.personal_consent_policy_id,
          personal_id: element.personal_id,
          codigo: element.operation_id,
          isActive: element.personal_response,
          atividade: element.operation_describe,
          data: format(new Date(element.modify_dt), 'dd/MM/yyyy'),
          total_itens: element.total_itens,
        });
      }
    });

    yield put(consentimentosSuccess(consentimentos));
  } catch (error) {
    yield put(consentimentosFailure());
  }
}

function* changeStateConsentimentos({
  payload,
}: ReturnType<typeof changeStateConsentimentosRequest>) {
  let { tempData } = store.getState().consentimentos;

  const consentimentos: any[] = [];

  const index = tempData.findIndex(
    (index: any) =>
      index.personal_consent_policy_id === payload.personal_consent_policy_id,
  );

  if (tempData.length > 0 && index !== -1) {
    //@ts-ignore
    tempData.forEach(element => {
      consentimentos.push({
        personal_consent_policy_id: element.personal_consent_policy_id,
        personal_id: element.personal_id,
        codigo: element.codigo,
        isActive: element.isActive,
        atividade: element.atividade,
      });
    });

    consentimentos[index].isActive = payload.isActive;
  } else {
    //@ts-ignore
    tempData.forEach(element => {
      consentimentos.push({
        personal_consent_policy_id: element.personal_consent_policy_id,
        personal_id: element.personal_id,
        codigo: element.codigo,
        isActive: element.isActive,
        atividade: element.atividade,
      });
    });
    consentimentos.push({
      personal_consent_policy_id: payload.personal_consent_policy_id,
      personal_id: payload.personal_id,
      codigo: payload.codigo,
      isActive: payload.isActive,
      atividade: payload.atividade,
    });
  }

  yield put(changeStateConsentimentosSuccess(consentimentos));
}

function* updateconsentimentos({
  payload,
}: ReturnType<typeof postConsentimentosRequest>) {
  const { token } = store.getState().auth;
  let { tempData } = store.getState().consentimentos;

  const data: any = [];

  tempData.forEach((element: any) => {
    data.push({
      personal_consent_policy_id: element.personal_consent_policy_id,
      personal_id: element.personal_id,
      operation_id: element.codigo,
      personal_response: element.isActive,
      operation_describe: element.atividade,
    });
  });

  try {
    yield call(api.post, '/v1/consentimentos', data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'g-recaptcha-response': payload.config.recaptcha,
      },
    });

    yield put(postConsentimentosSuccess());
    yield put(consentimentosRequest(0, 5));
    yield put(resetConsentimentosSuccess());

    const toastrConfirmOptions = {
      onOk: () => {},
      onCancel: () => {},
      okText: 'Ok',
      disableCancel: true,
    };

    toastr.confirm(
      'Alteração de consentimento efetuada com sucesso.',
      toastrConfirmOptions,
    );
  } catch (error) {
    const toastrConfirmOptions = {
      onOk: () => {},
      onCancel: () => {},
      okText: 'Ok',
      disableCancel: true,
    };

    toastr.confirm(
      'Problemas no acesso ao servidor. Por favor, tente mais tarde.',
      toastrConfirmOptions,
    );

    yield put(postConsentimentosFailure());
  }
}

export default all([
  takeLatest(ConsentimentosType.CONTRATO_RESQUEST, contratos),
  takeLatest(ConsentimentosType.CONSENTIMENTOS_RESQUEST, consentimentos),
  takeLatest(
    ConsentimentosType.CHANGE_STATE_CONSENTIMENTOS_RESQUEST,
    changeStateConsentimentos,
  ),
  takeLatest(
    ConsentimentosType.POST_CONSENTIMENTOS_RESQUEST,
    updateconsentimentos,
  ),
  takeLatest(ConsentimentosType.RESET_TEMPDATA, updateconsentimentos),
  takeLatest(
    ConsentimentosType.GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_RESQUEST,
    getOrderHandleChangeRowsPerPage,
  ),
  takeLatest(
    ConsentimentosType.GET_ORDER_HANDLE_CHANGE_PAGE_RESQUEST,
    getOrderHandleChange,
  ),
]);
